import Environment from "./Environment.js";

const getEnv = (url) => {
  switch (true) {
    case url.includes("localhost"):
      return Environment.DEV;
    case url.includes("test.healthyapps.dev"):
      return Environment.TEST;
    case url.includes("api.healthyapps.dev"):
      return Environment.PROD;
    default:
      throw new Error("Unhandled environment.");
  }
};

const serverURL = (env) => {
  switch (env) {
    case Environment.DEV:
      return "http://localhost:3001";
    case Environment.TEST:
      return "https://test.healthyapps.dev";
    case Environment.PROD:
      return "https://api.healthyapps.dev";
    default:
      throw new Error("Unhandled server environment.");
  }
};

const clientURL = (env) => {
  switch (env) {
    case Environment.DEV:
      return "http://localhost:3000";
    case Environment.TEST:
      return "https://test.healthyapps.dev";
    case Environment.PROD:
      return "https://api.healthyapps.dev";
    default:
      throw new Error("Unhandled client environment.");
  }
};

const urlConfig = { getEnv, serverURL, clientURL };
export default urlConfig;
